import React from 'react';

const PortalHome = () => {
  return (
    <div className='flex-1'>Quang Minh English Center</div>
  )
}

export default PortalHome